import { render, staticRenderFns } from "./ImageMetadataModal.vue?vue&type=template&id=3972d4aa&scoped=true&"
import script from "./ImageMetadataModal.vue?vue&type=script&lang=js&"
export * from "./ImageMetadataModal.vue?vue&type=script&lang=js&"
import style0 from "./ImageMetadataModal.vue?vue&type=style&index=0&id=3972d4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3972d4aa",
  null
  
)

export default component.exports